<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Nuevo Usuario</h4>
    <hr />

    <!-- ── Modal con dos pasos ────────────────────────────────────── -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">Crear Usuario</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">

            <!-- Indicador de pasos -->
            <div class="d-flex align-items-center mb-4">
              <div class="d-flex align-items-center gap-2" :class="paso === 1 ? 'text-primary fw-bold' : 'text-muted'">
                <span class="badge rounded-pill" :class="paso === 1 ? 'bg-primary' : (pasoPersonaOk ? 'bg-success' : 'bg-secondary')">1</span>
                Datos Persona
              </div>
              <div class="flex-grow-1 border-top mx-3"></div>
              <div class="d-flex align-items-center gap-2" :class="paso === 2 ? 'text-primary fw-bold' : 'text-muted'">
                <span class="badge rounded-pill" :class="paso === 2 ? 'bg-primary' : 'bg-secondary'">2</span>
                Datos Usuario
              </div>
            </div>

            <!-- ── PASO 1: Persona ─────────────────────────────── -->
            <div v-show="paso === 1">
              <div class="alert alert-info py-2 small mb-3">
                Complete los datos de la persona. Al finalizar, avance al paso 2 para configurar el acceso al sistema.
              </div>
              <!-- Tipo Id / Documento / Estado Civil -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Tipo Id.</label></div>
                  <div class="col-2">
                    <select class="form-select" v-model="datoPersona.idTipoIden">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="t in tipoIdens" :value="t.idTipoIden" :key="t.idTipoIden">{{ t.nombre }}</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Documento</label></div>
                  <div class="col-2">
                    <input type="text" class="form-control" v-model="datoPersona.documento" style="text-transform:uppercase" />
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Estado Civil</label></div>
                  <div class="col-2">
                    <select class="form-select" v-model="datoPersona.idEstadoCivil">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="e in estadoCivils" :value="e.idEstadoCivil" :key="e.idEstadoCivil">{{ e.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- FechaNac / Sexo / Teléfono -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Fecha Nac.</label></div>
                  <div class="col-2">
                    <input type="date" class="form-control" v-model="datoPersona.fechaNac" />
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Sexo</label></div>
                  <div class="col-2">
                    <select class="form-select" v-model="datoPersona.sexo">
                      <option value="">Seleccione...</option>
                      <option value="M">Masculino</option>
                      <option value="F">Femenino</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Teléfono</label></div>
                  <div class="col-2">
                    <input type="text" class="form-control" v-model="datoPersona.telefono" />
                  </div>
                </div>
              </div>
              <!-- Nombres -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Primer Nombre</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.primerNombre" style="text-transform:uppercase" />
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Segundo Nombre</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.segundoNombre" style="text-transform:uppercase" />
                  </div>
                </div>
              </div>
              <!-- Apellidos -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Primer Apellido</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.primerApellido" style="text-transform:uppercase" />
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Segundo Apellido</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.segundoApellido" style="text-transform:uppercase" />
                  </div>
                </div>
              </div>
              <!-- Localidad / Email -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Localidad</label></div>
                  <div class="col-4">
                    <select class="form-select" v-model="datoPersona.idLocalidad">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="l in localidads" :value="l.idLocalidad" :key="l.idLocalidad">{{ l.nombre }}</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Email</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.email" />
                  </div>
                </div>
              </div>
              <!-- Dirección -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Dirección</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPersona.direccion" style="text-transform:uppercase" />
                  </div>
                </div>
              </div>
            </div>

            <!-- ── PASO 2: Usuario ─────────────────────────────── -->
            <div v-show="paso === 2">
              <div class="alert alert-info py-2 small mb-3">
                Configure las credenciales y permisos de acceso al sistema.
                <span v-if="pasoPersonaOk" class="text-success fw-bold ms-2">
                  ✓ Persona: {{ datoPersona.primerNombre }} {{ datoPersona.primerApellido }}
                </span>
              </div>
              <!-- Empresa -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Empresa</label></div>
                  <div class="col-9">
                    <select class="form-select" v-model="datoUsuario.idEmpresa">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="e in empresas" :key="e.idEmpresa" :value="e.idEmpresa">{{ e.nombreCorto }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Perfil -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Perfil</label></div>
                  <div class="col-9">
                    <select class="form-select" v-model="datoUsuario.idPerfil" @change="aplicarPermisosPerfil">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="p in perfils" :key="p.idPerfil" :value="p.idPerfil">{{ p.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Nombre usuario / Clave -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Nombre usuario</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoUsuario.nombre" style="text-transform:uppercase"
                      :placeholder="sugerenciaNombre" />
                    <small class="text-muted">Sugerencia: {{ sugerenciaNombre }}</small>
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Clave</label></div>
                  <div class="col-3">
                    <input type="password" class="form-control" v-model="datoUsuario.clave"
                      autocomplete="new-password" placeholder="Ingrese la clave" />
                    <small class="text-muted">Se almacenará encriptada.</small>
                  </div>
                </div>
              </div>
              <!-- Permisos -->
              <div class="card mt-2">
                <div class="card-header bg-secondary text-white py-1 d-flex justify-content-between align-items-center">
                  <span class="small fw-bold">Permisos de módulos y menús</span>
                  <small class="text-white-50">Se cargan al seleccionar el perfil</small>
                </div>
                <div class="card-body py-2">
                  <div class="row g-2">
                    <div class="col-6 col-md-4" v-for="campo in camposModulos" :key="campo.field">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :id="campo.field"
                          :true-value="1"
                          :false-value="0"
                          v-model="datoUsuario[campo.field]"
                        />
                        <label class="form-check-label small" :for="campo.field">{{ campo.label }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- Footer con navegación entre pasos -->
          <div class="modal-footer d-flex justify-content-between">
            <div>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                Cancelar
              </button>
            </div>
            <div class="d-flex gap-2">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="paso = 1"
                v-if="paso === 2"
              >
                <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">arrow_back</span>
                Anterior
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="avanzarPaso2"
                v-if="paso === 1"
              >
                Siguiente
                <span class="material-icons ms-1" style="font-size:18px;vertical-align:middle">arrow_forward</span>
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="guardarTodo"
                v-if="paso === 2"
                :disabled="guardando"
              >
                <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
                <span v-else class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
                Crear Usuario
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Botón para abrir el modal -->
    <button class="btn btn-primary d-flex align-items-center gap-1" @click="abrirModal">
      <span class="material-icons" style="font-size:18px">person_add</span>
      Nuevo Usuario
    </button>

    <Footer />
  </div>
</template>

<script>
import Layout                     from "@/components/Layout.vue";
import Footer                     from "@/components/Footer.vue";
import api                        from "@/services/api";
import { validarForm }            from "@/modules/validacionesForms.js";
import Swal                       from "sweetalert2";
import * as $                     from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "UsuarioNuevo",
  components: { Layout, Footer },
  data() {
    return {
      paso:          1,
      pasoPersonaOk: false,
      guardando:     false,
      modalWindow:   true,
      // Persona
      datoPersona:  {},
      tipoIdens:    [],
      localidads:   [],
      estadoCivils: [],
      // Usuario
      datoUsuario:  {},
      empresas:     [],
      perfils:      [],
      camposModulos: [
        { label: "Módulo Administración", field: "moduloAdministracion" },
        { label: "Módulo Atención",       field: "moduloAtencion"       },
        { label: "Módulo Auditoría",      field: "moduloAuditoria"      },
        { label: "Módulo Facturación",    field: "moduloFacturacion"    },
        { label: "Módulo Dashboards",     field: "moduloDashboards"     },
        { label: "Menú Parámetros",       field: "menuParametros"       },
        { label: "Menú Procesos",         field: "menuProcesos"         },
        { label: "Menú Reportes",         field: "menuReportes"         },
        { label: "Menú Ayuda",            field: "menuAyuda"            },
        { label: "Opción Consulta",       field: "opcionConsulta"       },
        { label: "Opción Operaciones",    field: "opcionOperaciones"    },
        { label: "Opción Descarga",       field: "opcionDescarga"       },
        { label: "Opción Menú",           field: "opcionMenu"           },
      ],
    };
  },
  computed: {
    // Sugiere nombre de usuario a partir de los datos de persona
    sugerenciaNombre() {
      const p = this.datoPersona;
      if (!p.primerNombre || !p.primerApellido) return "";
      return (p.primerNombre.charAt(0) + p.primerApellido).toUpperCase();
    },
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchTipoIdens();
    this.fetchLocalidads();
    this.fetchEstadoCivils();
    this.fetchEmpresas();
    this.fetchPerfils();
  },
  methods: {
    // ── Fetch auxiliares ──────────────────────────────────
    async fetchTipoIdens()   { try { this.tipoIdens    = (await api.get("/vwtipoidens")).data;    } catch(e) { console.error(e); } },
    async fetchLocalidads()  { try { this.localidads   = (await api.get("/vwlocalidads")).data;   } catch(e) { console.error(e); } },
    async fetchEstadoCivils(){ try { this.estadoCivils = (await api.get("/vwestadocivils")).data; } catch(e) { console.error(e); } },
    async fetchEmpresas()    { try { this.empresas     = (await api.get("/vwempresas")).data;     } catch(e) { console.error(e); } },
    async fetchPerfils()     { try { this.perfils      = (await api.get("/vwperfils")).data;      } catch(e) { console.error(e); } },

    // ── Abrir modal ───────────────────────────────────────
    abrirModal() {
      this.paso          = 1;
      this.pasoPersonaOk = false;
      this.datoPersona   = {};
      const hoy          = new Date();
      const fechaVig     = new Date();
      fechaVig.setDate(hoy.getDate() + 90);
      this.datoUsuario = {
        idEmpresa:            window.sessionStorage.getItem("idEmpresa"),
        fechaReg:             hoy.toISOString(),
        fechaVigClave:        fechaVig.toISOString(),
        moduloAdministracion: 0, moduloAtencion:   0, moduloAuditoria: 0,
        moduloFacturacion:    0, moduloDashboards: 0,
        menuParametros:       0, menuProcesos:     0, menuReportes:  0, menuAyuda:      0,
        opcionConsulta:       0, opcionOperaciones:0, opcionDescarga:0, opcionMenu:     0,
      };
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    // ── Validar paso 1 y avanzar ──────────────────────────
    avanzarPaso2() {
      const fields = [
        "idTipoIden","idLocalidad","idEstadoCivil","documento",
        "primerNombre","segundoNombre","primerApellido","segundoApellido",
        "fechaNac","direccion","telefono","sexo","email",
      ];
      if (validarForm(this.datoPersona, fields, fields) !== 1) return;
      // Sugerir nombre de usuario si está vacío
      if (!this.datoUsuario.nombre) {
        this.datoUsuario.nombre = this.sugerenciaNombre;
      }
      this.pasoPersonaOk = true;
      this.paso = 2;
    },

    // ── Permisos desde perfil ─────────────────────────────
    aplicarPermisosPerfil() {
      const perfil = this.perfils.find(p => p.idPerfil === this.datoUsuario.idPerfil);
      if (!perfil) return;
      this.camposModulos.forEach(c => {
        this.datoUsuario[c.field] = perfil[c.field] ?? 0;
      });
    },

    // ── Guardar persona + usuario ─────────────────────────
    async guardarTodo() {
      // Validar campos de usuario
      const fieldsUsuario = ["idPerfil", "nombre", "clave"];
      if (validarForm(this.datoUsuario, fieldsUsuario, fieldsUsuario) !== 1) return;

      this.guardando = true;
      try {
        // 1. Guardar persona
        this.datoPersona.idEmpresa   = window.sessionStorage.getItem("idEmpresa");
        this.datoPersona.tipoPersona = "N";
        const respPersona = await api.post("/personas", this.datoPersona);

        // 2. Obtener el idPersona creado
        const idPersona = respPersona.data?.idPersona ?? respPersona.data;

        // 3. Guardar usuario enlazado a la persona
        this.datoUsuario.idPersona    = idPersona;
        this.datoUsuario.idPrestador  = 1;
        this.datoUsuario.idSuscripcion = window.sessionStorage.getItem("idSuscripcion");
        this.datoUsuario.idUsuarioReg  = window.sessionStorage.getItem("idUsuario");
        this.datoUsuario.moduloAuditoria = 1;
        await api.post("/usuarios", this.datoUsuario);

        $("#ventanaModal").modal("hide");
        Swal.fire({
          icon: "success",
          title: "¡Usuario creado!",
          html: `
            <p>Persona y usuario registrados exitosamente.</p>
            <p><strong>Usuario:</strong> ${this.datoUsuario.nombre}</p>
          `,
        });
      } catch (error) {
        const msg = error.response?.data?.message ?? error.response?.data ?? "Error al guardar.";
        Swal.fire({ icon: "error", title: "Error", text: String(msg) });
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>